import * as React from 'react';
import type { SVGProps } from 'react';

const SvgSafariPinnedTab = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={346.667}
    height={346.667}
    viewBox="0 0 260 260"
    {...props}
  >
    <path d="M108.1 2.6C68 9.3 31.4 36.7 13.7 73.2-1 103.4-3.4 137.1 6.6 169.4c3.5 11.1 10.5 25.1 17.3 34.5 32.9 45.9 87.5 65 142.9 50.1 10.5-2.9 31.6-13.3 40.7-20.2 25.9-19.7 43.6-47.6 50.1-79.3 2.5-12.3 2.6-36.6.1-48.5-8.8-41.4-34.1-74.2-71.2-92.1-13-6.3-21.9-9.1-36-11.4-11.1-1.8-31.2-1.8-42.4.1zM178 80.3c0 10.8-.1 10.8-19 15.3l-16 3.8v61.2l16 3.8c18.9 4.5 19 4.5 19 15.3v7.3l-47.7-.2-47.8-.3-.3-5.9c-.4-7.2 1.1-11.1 4.6-12.5 1.5-.5 8.9-2.4 16.5-4.1l13.7-3.2V99.3l-13.7-3.2c-17.1-4-18.8-4.6-20.2-7.7-1.2-2.7-1.5-13.6-.4-14.7.3-.4 21.9-.7 48-.7H178v7.3z" />
  </svg>
);
export default SvgSafariPinnedTab;
